export const AlertTags = {
   InlineAlert: 'atlantis-alert',
};

class DismissAlertEvent extends Event {
   static EVENT_NAME = 'atlantis-dismiss-alert';
   constructor() {
      super(DismissAlertEvent.EVENT_NAME, { bubbles: true, composed: true });
   }
}

export interface AtlInlineAlertProps {
   variant: AlertVariant;
   showIcon?: boolean;
   iconName?: string;
   dismissable?: boolean;
   alertClassName?: string;
}

export enum AlertVariant {
   Success = 'Success',
   Neutral = 'Neutral',
   Warning = 'Warning',
   Info = 'Info',
   Error = 'Error',
   Highlight = 'Highlight',
   SuccessBordered = 'SuccessBordered',
   NeutralBordered = 'NeutralBordered',
   WarningBordered = 'WarningBordered',
   InfoBordered = 'InfoBordered',
   ErrorBordered = 'ErrorBordered',
}

export const AlertEnums = {
   AlertVariant,
} as const;

export const AlertEvents = {
   DismissAlertEvent,
} as const;
